import React, { useState } from 'react';
import { useDeleteBatiment } from '../hooks/useBatiments';

interface BulkDeleteBatimentsModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedBatiments: any[];
  onSuccess: () => void;
}

const BulkDeleteBatimentsModal: React.FC<BulkDeleteBatimentsModalProps> = ({
  isOpen,
  onClose,
  selectedBatiments,
  onSuccess
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const deleteBatiment = useDeleteBatiment();

  const handleDelete = async () => {
    setIsLoading(true);

    try {
      const deletePromises = selectedBatiments.map(batiment => 
        deleteBatiment.mutateAsync(batiment.id)
      );

      await Promise.all(deletePromises);
      onSuccess();
      onClose();
    } catch (error) {
      console.error('Erreur lors de la suppression en masse:', error);
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <h2 className="text-lg font-semibold mb-4 text-red-600">
          Supprimer {selectedBatiments.length} bâtiment{selectedBatiments.length > 1 ? 's' : ''}
        </h2>

        <div className="mb-6">
          <p className="text-gray-700 mb-4">
            Êtes-vous sûr de vouloir supprimer {selectedBatiments.length} bâtiment{selectedBatiments.length > 1 ? 's' : ''} ?
          </p>
          
          <div className="bg-red-50 border border-red-200 rounded-md p-3">
            <p className="text-sm text-red-800">
              ⚠️ <strong>Attention :</strong> Cette action supprimera également toutes les pièces, 
              zones et objets associés à ces bâtiments.
            </p>
          </div>

          <div className="mt-3">
            <p className="text-sm font-medium text-gray-700 mb-2">Bâtiments à supprimer :</p>
            <ul className="text-sm text-gray-600 max-h-32 overflow-y-auto">
              {selectedBatiments.map(batiment => (
                <li key={batiment.id} className="py-1">• {batiment.nom}</li>
              ))}
            </ul>
          </div>
        </div>

        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 transition-colors"
          >
            Annuler
          </button>
          <button
            onClick={handleDelete}
            disabled={isLoading}
            className="flex-1 px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 disabled:opacity-50 transition-colors"
          >
            {isLoading ? 'Suppression...' : 'Supprimer'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkDeleteBatimentsModal;
